export const screens = {
  desktop: '1500px',
  tablet: '768px',
  mobile: '375px',
}
